<template>
  <div class="footer">
    <div class="footer-logo">
      <img src="@/assets/logo&name.svg" class="logo-img" alt="" />
      <div
        class="language my400 fs18 fc000000"
        @click="languateShow = !languateShow">
        中文简
        <img src="@/assets/icon/triangle-black.png" class="triangle" alt="" />
        <div class="choice-langeage my400 fs18 fcFFFFFF" v-show="languateShow">
          中文简
        </div>
      </div>
    </div>
    <div class="footer-introduce">
      <div class="introduce-top">
        <div class="company" @click="toPath('/')">
          <div class="title my600 fs28 fc000000">关于我们</div>
          <div class="describe">
            <div
              class="item my400 fs22 fc000000"
              v-for="(item, index) in company"
              :key="index"
              @click.stop="toPath('/', item.anchor)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="news">
          <div class="title my600 fs28 fc000000">我们的产品</div>
          <div class="describe">
            <div class="item my400 fs22 fc000000" @click="toPath('/product')">产品简介</div>
          </div>
        </div>
        <div class="social" >
          <div class="title my600 fs28 fc000000">新闻动态</div>
          <!-- <div class="item my400 fs22 fc000000">社会责任动态</div> -->
        </div>
        <div class="join">
          <div class="title my600 fs28 fc000000">加入我们</div>
          <!-- <div class="item my400 fs22 fc000000">招聘官网</div> -->
        </div>
      </div>
      <div class="introduce-bottom my400 fs20 fc000000">
        <div class="name">© 2025-2026 千里知行</div>
        <div class="record">
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=33011002019590"
            target="_blank"
            rel="noopener noreferrer"
            class="record-link gongan-link my400 fs20 fc000000">
            <img src="@/assets/beian.png" class="gongan-icon" alt="公安备案图标" />
            浙公网安备33011002019590号
          </a>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            class="record-link my400 fs20 fc000000">
            浙ICP备2026032880号-1
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref } from "vue";
  import { useRoute, useRouter } from "vue-router";

  const route = new useRoute();
  const router = new useRouter();

  const company = ref([
    { name: "企业精神", anchor: "spirit" },
    { name: "大事记", anchor: "events" }
  ]);
  const languateShow = ref(false);

  const toPath = (path, anchor) => {
    if (anchor) {
      router.push("/").then(() => {
        setTimeout(() => {
          const element = document.getElementById(anchor);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      });
    } else {
      router.push(path);
    }
  };
</script>
<style lang="less" scoped>
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    min-width: 1200px;
    height: 365px;
    box-shadow: 0px 0px 29px 0px rgba(148, 148, 148, 0.6);
    padding: 0 180px;
    box-sizing: border-box;

    .footer-logo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 40px;
      width: 500px;
      height: 270px;
      // cursor: pointer;

      .logo-img {
        width: 250px;
        height: 50%;
        object-fit: contain;
      }

      .language {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 0 10px;
        margin-top: 160px;
        margin-left: 10px;
        width: 150px;
        height: 30px;
        border: 1px solid #000000;
        box-sizing: border-box;
        cursor: default;

        .choice-langeage {
          position: absolute;
          left: 0;
          bottom: -35px;
          padding-left: 10px;
          box-sizing: border-box;
          width: 150px;
          height: 30px;
          line-height: 30px;
          background: #000000;
          cursor: pointer;
        }
      }
    }

    .footer-introduce {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 300px;
      margin-top: 50px;
      width: 800px;
      height: 270px;

      .introduce-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        height: 180px;
        padding: 0 20px;
        box-sizing: border-box;

        .company, .news, .social, .join {
          width: 160px;
          height: 100%;
        }

        .title {
          margin-bottom: 20px;
          text-align: left;
        }

        .company, .news {
          .describe {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: left;
            .item {
              cursor: pointer;
            }
            .item + .item {
              margin-top: 12px;
            }
          }
        }

        .item {
          cursor: pointer;
        }
      }

      .introduce-bottom {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 100%;
        height: 60px;

        .name {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
        }

        .record {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          margin-top: 5px;
          gap: 20px;

          .record-link {
            color: inherit;
            text-decoration: none;
          }

          .gongan-link {
            display: flex;
            flex-direction: row;
            align-items: center;
          }

          .gongan-icon {
            width: 28px;
            height: 28px;
            object-fit: contain;
            margin-right: 8px;
          }
        }
      }
    }
  }
</style>
